module.exports = __webpack_public_path__ + "static/img/达摩盘.d205d52b.png";